import React from 'react';
import { push } from 'react-router-redux';
import AuthRequiredComponent from "../components/common/AuthRequiredComponent";
import {connect} from "react-redux";
import * as authHandler from "../utils/authHandler";
import * as routes from "../constants/routes";

class Logout extends AuthRequiredComponent {
    componentDidMount() {
        authHandler.clearTokenAndUser();
        this.props.dispatch(push(routes.LOGIN))
    }

    render() {
        return (
            <div className="flex-full-wrapper login-page">
                <div className="top-left-logo"><img src="/images/brand.png" alt="Intertek" /></div>
                <div className="centered-box"></div>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
    });
})(Logout);



// WEBPACK FOOTER //
// ./src/containers/Logout.js